export default "__VITE_ASSET__Dgl6h7Fp__"